(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(14186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_AppNavBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7486);
/* harmony import */ var _components_home_1_landing_Landing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61612);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);





// Dynamic Imports

const Stats = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 9099).then(__webpack_require__.bind(__webpack_require__, 9099)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9099)
            ]
    }
});
const TheProcess = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(1529), __webpack_require__.e(9464), __webpack_require__.e(7027), __webpack_require__.e(8104)]).then(__webpack_require__.bind(__webpack_require__, 42910)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(42910)
            ]
    }
});
const Features = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1529), __webpack_require__.e(7027), __webpack_require__.e(4437)]).then(__webpack_require__.bind(__webpack_require__, 67533)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(67533)
            ]
    }
});
const FeatureScroll = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(1129), __webpack_require__.e(7027), __webpack_require__.e(6101)]).then(__webpack_require__.bind(__webpack_require__, 56101)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56101)
            ]
    }
});
const OurProducts = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(7027), __webpack_require__.e(6191)]).then(__webpack_require__.bind(__webpack_require__, 36191)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(36191)
            ]
    }
});
const Brand = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(4938), __webpack_require__.e(7027), __webpack_require__.e(2631)]).then(__webpack_require__.bind(__webpack_require__, 59584)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(59584)
            ]
    }
});
const Testimonials = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(8050), __webpack_require__.e(1781), __webpack_require__.e(2959)]).then(__webpack_require__.bind(__webpack_require__, 21781)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(21781)
            ]
    }
});
const Blogs = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 6978).then(__webpack_require__.bind(__webpack_require__, 36978)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(36978)
            ]
    }
});
const Press = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(4938), __webpack_require__.e(7027), __webpack_require__.e(1420)]).then(__webpack_require__.bind(__webpack_require__, 14241)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(14241)
            ]
    }
});
const AppFooter = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5045), __webpack_require__.e(5754)]).then(__webpack_require__.bind(__webpack_require__, 5754)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5754)
            ]
    }
});
const ApplicationCTA = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 8069).then(__webpack_require__.bind(__webpack_require__, 98069)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98069)
            ]
    }
});
const Home = (param)=>{
    let { initialNavColor  } = param;
    const [navColor, setNavColor] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialNavColor);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY > 100) {
                setNavColor("#002561");
            } else {
                setNavColor("transparent");
            }
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll(); // Set the initial color based on the current scroll position
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Gromo: Earn money online by Selling Financial Products"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Gromo is India's best real money earning app to earn extra income online without investment. Become a Gromo partner to Sell financial products & earn real money."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "GroMo Money Making Application"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://gromo.in"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Earn money online by Selling Financial Products"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Gromo is India's best real money earning app to earn extra income online without investment. Become a Gromo partner to Sell financial products & earn real money."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://gromo.in"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: "h5cwilbbvtk9ui5zbw1dn1i47ohmj1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:title",
                        content: "Become A Certified Financial Advisor, Earn Money up to ₹1 Lakh"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:description",
                        content: "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://gromo.in"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AppNavBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                navBgColor: navColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_1_landing_Landing__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Stats, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TheProcess, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Features, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureScroll, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OurProducts, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Brand, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Testimonials, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Press, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Blogs, {
                heading: "GroMo Blogs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ApplicationCTA, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppFooter, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9194,6886,5675,2093,7538,757,7486,1612,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);